const FORMATTER_LOOKUP = [
  { value: 1, symbol: "" },
  { value: 1e3, symbol: "k" },
  { value: 1e6, symbol: "M" },
  { value: 1e9, symbol: "G" },
  { value: 1e12, symbol: "T" },
  { value: 1e15, symbol: "P" },
  { value: 1e18, symbol: "E" }
];
const FORMATTER_RX = /\.0+$|(\.[0-9]*[1-9])0+$/;

export const formatterToUnits = (number: number, precision: number = 0) => {
  const item = FORMATTER_LOOKUP.slice().reverse().find(item => number >= item.value);

  return item ? (number / item.value).toFixed(precision).replace(FORMATTER_RX, "$1") + item.symbol : "0";
};

export function isNumeric(value: any) {
  return /^-?\d+$/.test(value);
}
